document.addEventListener('alpine:init', function () {
    Alpine.data('header', function (primaryNav) {
        return {
            mobileMenuOpen: false,
            mobileMenuActiveIndex: 1,
            mobileLevel2Nav: {},
            mobileLevel3Nav: {},
            mobileLevel4Nav: {},
            searchOpen: false,
            searchQuery: '',
            desktopActiveMenu: '',
            desktopLevel2Nav: {},
            desktopLevel3Nav: {},
            desktopLevel4Nav: {},
            toggleMobileMenu: function (force) {
                var _this = this;
                // Close search if it's open.
                if (this.searchOpen)
                    this.toggleSearch();
                if (typeof force === 'boolean') {
                    this.mobileMenuOpen = force;
                }
                else {
                    this.mobileMenuOpen = !this.mobileMenuOpen;
                }
                // Reset mobile menu state on open/close.
                this.mobileMenuActiveIndex = 1;
                // document.body.classList.toggle('overflow-hidden', this.mobileMenuOpen);
                document.body.classList.toggle('fixed', this.mobileMenuOpen);
                document.body.classList.toggle('overflow-y-scroll', this.mobileMenuOpen);
                document.body.classList.toggle('w-full', this.mobileMenuOpen);
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level1Nav).first();
                });
                this.searchOpen = false;
            },
            mobileBack: function () {
                var _this = this;
                this.mobileMenuActiveIndex = Math.max(this.mobileMenuActiveIndex - 1, 1);
                this.$nextTick(function () {
                    switch (_this.mobileMenuActiveIndex) {
                        case 2:
                            _this.$focus.within(_this.$refs.level2Nav).first();
                            break;
                        case 3:
                            _this.$focus.within(_this.$refs.level3Nav).first();
                            break;
                        case 4:
                            _this.$focus.within(_this.$refs.level4Nav).first();
                            break;
                    }
                });
            },
            setLevel2MobileNav: function (title) {
                var _this = this;
                this.mobileLevel2Nav = primaryNav.find(function (nav) { return nav.title === title; });
                this.mobileMenuActiveIndex = 2;
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level2Nav).first();
                });
            },
            setLevel3MobileNav: function (title) {
                var _this = this;
                this.mobileLevel3Nav = this.mobileLevel2Nav.children.find(function (nav) { return nav.title === title; });
                this.mobileMenuActiveIndex = 3;
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level3Nav).first();
                });
            },
            setLevel4MobileNav: function (title) {
                var _this = this;
                this.mobileLevel4Nav = this.mobileLevel3Nav.children.find(function (nav) { return nav.title === title; });
                this.mobileMenuActiveIndex = 4;
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level4Nav).first();
                });
            },
            toggleSearch: function () {
                var _this = this;
                // If mobile menu is open, close it.
                if (this.mobileMenuOpen)
                    this.toggleMobileMenu();
                this.searchOpen = !this.searchOpen;
                if (this.searchOpen) {
                    this.$nextTick(function () {
                        _this.$focus.focus(_this.$refs.searchField);
                    });
                }
            },
            toggleDesktopMenu: function (title) {
                var _this = this;
                this.desktopActiveMenu = this.desktopActiveMenu === title ? '' : title;
                // document.body.classList.toggle('overflow-hidden', this.desktopActiveMenu !== '');
                document.body.classList.toggle('fixed', this.desktopActiveMenu !== '');
                document.body.classList.toggle('overflow-y-scroll', this.desktopActiveMenu !== '');
                document.body.classList.toggle('w-full', this.desktopActiveMenu !== '');
                if (this.desktopActiveMenu === 'Search') {
                    setTimeout(function () {
                        _this.$refs.searchField.focus();
                    }, 100);
                }
                else if (this.desktopActiveMenu) {
                    this.desktopLevel2Nav = primaryNav.find(function (nav) { return nav.title === title; });
                    // Open the first link within the level 2 nav so that the menu doesn't look empty.
                    if (this.desktopLevel2Nav.children.length) {
                        this.desktopLevel3Nav = this.desktopLevel2Nav.children[0];
                    }
                    else {
                        this.desktopLevel3Nav = {};
                    }
                    this.desktopLevel4Nav = {};
                    this.$nextTick(function () {
                        _this.$focus.within(_this.$refs.level2Nav).first();
                    });
                }
            },
            setLevel3DesktopNav: function (title) {
                var _this = this;
                this.desktopLevel3Nav = this.desktopLevel2Nav.children.find(function (nav) { return nav.title === title; });
                this.desktopLevel4Nav = {};
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level3Nav).first();
                });
            },
            setLevel4DesktopNav: function (title) {
                var _this = this;
                this.desktopLevel4Nav = this.desktopLevel3Nav.children.find(function (nav) { return nav.title === title; });
                this.$nextTick(function () {
                    _this.$focus.within(_this.$refs.level4Nav).first();
                });
            },
        };
    });
});
